{
  if(window.hanlin === undefined || window.hanlin === null){
    window.hanlin = {}
  }
  window.hanlin.constant = {
    PAGE_TYPE: {
      I_BOOK: "I_BOOK",
      I_FAVORITE: "I_FAVORITE"
    },

    DEVICE_TYPE: {
      PC: "PC",
      MOBILE: "MOBILE"
    },

    BOOK_DISPLAY_TYPE: {
      DETAIL: "DETAIL",
      ALL: "ALL"
    },

    AD_DISPLAY_TYPE: {
      INDEX: "INDEX",
      SUBJECT: "SUBJECT"
    },

    FOOTER_TYPE: {
      INDEX: "INDEX",
      SUBJECT: "SUBJECT"
    },

    EDU_SUBJECT_MAP: {
      "國小": ['國語', '英語', '數學','生活','自然','社會'],
      "國中": ['國文','英語','數學', '自然', '歷史', '地理', '公民'],
      "高中": ['國文', '英文', '數學', '物理', '化學', '生物', '地科', '歷史', '地理', '公民', '技高國文', '技高英文']
    }
  }
}
